export const SET_EXPOSURE = "SET_EXPOSURE";

export const SET_BALANCE = "SET_BALANCE";

export const SET_MATCH = "SET_MATCH";

export const SET_GAME = "SET_GAME";



// WEBPACK FOOTER //
// ./src/redux/types.js